import type { OpacityScale } from '@/theme/types'

export const opacity: OpacityScale = {
  disabled: 0.38,
  hover: 0.08,
  focus: 0.12,
  overlay: 0.5,
  loading: 0.24,
}

